import script from "./BulkDeleteAnnotationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkDeleteAnnotationModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkDeleteAnnotationModal.vue?vue&type=style&index=0&id=19b3f20d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b3f20d"]])

export default __exports__